export default __webpack_public_path__ + "static/media/4 - Климатическое оборудование.325aa930.jpg";